import PropTypes from 'prop-types'
import React, { useState } from 'react'

import {
  ClaimCard,
  ConfirmBar,
  InfiniteScroll,
  Loader,
  Search,
  Typography,
} from 'components'

import EditReview from './EditReview'

import './reviewsWithNoAppearancePage.scss'

const ReviewWithNoAppearancePage = ({
  defaultSearch,
  fetchNextReviewPage,
  hasNextReviewPage,
  onSearch,
  refetchReviews,
  reviewIsLoading,
  reviews,
}) => {
  const [reviewId, setReviewId] = useState(reviews[0]?.id)
  
  const [showReviewEdited, setShowReviewEdited] = useState(false)
  const toggleShowReviewEdited = () => setShowReviewEdited(!showReviewEdited)

  const markReviewAsTreated = () => {
    setReviewId(null)
    toggleShowReviewEdited()
    setTimeout(() => {
      setShowReviewEdited(false)
    }, 3000)
  }

  return (
    <div className="reviews-with-no-appearances-page">
      <div className="reviews-with-no-appearances-page--reviews">
        <Typography variant="title-1">Claims without appearance:</Typography>
        <div className="reviews-with-no-appearances-page--reviews--search">
          <Search
            defaultSearch={defaultSearch}
            onSearch={onSearch}
            placeholder="Type a title, key word.. "
            variant="ghost"
          />
        </div>

        <div id="reviews-with-no-appearances-page--reviews--infinite-scroll">
          <InfiniteScroll
            className="reviews-with-no-appearances-page--reviews--review-list"
            dataLength={reviews.length}
            hasMore={hasNextReviewPage}
            isLoading={reviewIsLoading}
            loader={<Loader />}
            next={fetchNextReviewPage}
            scrollableTarget="reviews-with-no-appearances-page--reviews--infinite-scroll"
          >
            {reviews.map(review => (
              <div
                className="reviews-with-no-appearances-page--reviews--review-list--review"
                key={`review-${review.id}`}
                onClick={() => setReviewId(review.id)}
              >
                <ClaimCard
                  claim={review.claim}
                  claimBy={review.claimBy}
                  conclusionLabel={review.conclusionLabel}
                  conclusionScore={review.conclusionScore}
                  goToReview={false}
                  interactionNumber={undefined}
                  linkNumber={review.linkNumber}
                  links={undefined}
                  reviewId={review.id}
                />
              </div>
            ))}
          </InfiniteScroll>
        </div>
      </div>
      {reviewId && <EditReview 
        reviewId={reviewId} 
        refetchReviews={refetchReviews}
        resetReview={markReviewAsTreated} 
      />}

      <ConfirmBar
        checkAnimation
        onClose={toggleShowReviewEdited}
        show={showReviewEdited}
        text="Review marked as treated"
      />
    </div>
  )
}

export default ReviewWithNoAppearancePage

ReviewWithNoAppearancePage.defaultProps = {
  defaultSearch: '',
  hasNextReviewPage: undefined,
  refetchReviews: () => null,
  reviewIsLoading: true,
  reviews: [],
}

ReviewWithNoAppearancePage.propTypes = {
  defaultSearch: PropTypes.string,
  fetchNextReviewPage: PropTypes.func.isRequired,
  hasNextReviewPage: PropTypes.bool,
  onSearch: PropTypes.func.isRequired,
  refetchReviews: PropTypes.func,
  reviewIsLoading: PropTypes.bool,
  reviews: PropTypes.arrayOf(PropTypes.shape({})),
}
